import { Moment } from 'moment';
import {
  Control,
  Controller,
  FieldErrors,
  UseFormGetValues,
} from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Enum } from '~/data/enums';
import { useSxStyles } from '~/features/ScheduledEmploymentChanges/ScheduleChanges/components/Employment/components/FormComponent/useStyles';
import { useFilterActiveEnumsByFormSelections } from '~/features/ScheduledEmploymentChanges/ScheduleChanges/data/useFilterActiveEnumsByFormSelections';
import { Form } from '~/features/ScheduledEmploymentChanges/ScheduleChanges/useScheduleChanges';
import { LegacyAutocompleteField } from '~/legacy-components/LegacyForms';

type Props = {
  control: Control<Form>;
  errors: FieldErrors<Form>;
  getValues: UseFormGetValues<Form>;
  terminationReasons: Enum[];
  index: number;
  endOfEmploymentField: Moment | null;
  disabled?: boolean;
};

export const TerminationReasonComponent = ({
  control,
  terminationReasons,
  errors,
  index,
  getValues,
  endOfEmploymentField,
  disabled,
}: Props) => {
  const { t } = useTranslation();
  const sxStyles = useSxStyles();
  const requiredText = t('fieldIsRequired');

  const { filterActiveEnumsByFormSelections } =
    useFilterActiveEnumsByFormSelections({
      control,
      index,
      getValues,
    });

  const filteredOptions = filterActiveEnumsByFormSelections(terminationReasons);

  return (
    <Controller
      control={control}
      name={`schedule.${index}.employment.fEmplTerminationReason`}
      rules={{
        required: !!endOfEmploymentField && requiredText,
      }}
      render={({ field: { onChange, value } }) => (
        <LegacyAutocompleteField
          options={filteredOptions}
          disabled={disabled}
          getOptionLabel={(o) => o?.name || ''}
          isOptionEqualToValue={(o, v) => o?.code === v?.code}
          onChange={(_, value) => onChange(value?.code || '')}
          value={filteredOptions.find((o) => o?.code === value) || null}
          sx={sxStyles.selectStyle}
          required={!!endOfEmploymentField}
          fieldError={
            errors.schedule?.[index]?.employment?.fEmplTerminationReason
          }
          label={t('laTerminationReason')}
        />
      )}
    />
  );
};
